import envVars from 'helpers/envVars';
import request from 'helpers/request';

import * as DTO from './dto';

const domain = envVars('API_PAINEL_DIGITAL_BASE_URL');

export async function getCheckMeAccess({ dealerId }: DTO.CheckMeAccessQ) {
  return request
    .get(`${domain}/dealer/v1.0/${dealerId}/me/is-restricted-access`)
    .then(response => {
      return response?.data as DTO.CheckMeAccessR;
    });
}
